import { useIntl } from 'react-intl';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { profileMessages } from 'src/features/profile/utils/messages';

type ProfileLayoutProps = {
    children: React.ReactNode;
};

const ProfileLayout = ({ children }: ProfileLayoutProps) => {
    const { formatMessage } = useIntl();
    return (
        <div className="flex flex-col gap-4 sm:gap-6">
            <TabRow className="mt-0">
                <Tab to="/profile" end>
                    {formatMessage(profileMessages.details)}
                </Tab>
                <Tab to="/profile/password">{formatMessage(profileMessages.password)}</Tab>
                <Tab to="/profile/settings">{formatMessage(profileMessages.settings)}</Tab>
            </TabRow>
            {children}
        </div>
    );
};

export default ProfileLayout;
